import { get } from './index'

/**
 * 获取公司信息
 */
export const getCompanyInfo = () => get('/about/company')

/**
 * 获取平台信息
 */
export const getPlatformInfo = (locale = '') => {
  const localeParam = locale ? `?locale=${locale}` : ''
  return get(`/about/info${localeParam}`)
}
